import { CertificationProviderSearchInterface } from '../interfaces/certification-provider-search.interface';

export class CertificationProviderSearchCommand {
    statuses: number[];
    certifications_ids: number[];
    certification_providers_ids: number[];
    issue_date_from: string;
    issue_date_to: string;
    expiration_date_from: string;
    expiration_date_to: string;
    show_expiring_only: boolean;
    show_recently_expired_only: boolean;
    include_subteams_of_teams_in_filter: boolean;
    teams_ids: number[];
    excluded_teams_ids: number[];
    user_ids: number[];

    constructor(query: CertificationProviderSearchInterface) {
        if (query) {
            this.statuses = query.statuses;
            this.certifications_ids = query.certificationsIds.map((id) => parseInt(id));
            this.certification_providers_ids = query.certificationProvidersIds.map((id) => parseInt(id));
            this.issue_date_from = query.issueDateFrom ? query.issueDateFrom.format() : null;
            this.issue_date_to = query.issueDateTo ? query.issueDateTo.format() : null;
            this.expiration_date_from = query.expirationDateFrom ? query.expirationDateFrom.format() : null;
            this.expiration_date_to = query.expirationDateTo ? query.expirationDateTo.format() : null;
            this.show_expiring_only = query.showExpiringOnly;
            this.show_recently_expired_only = query.showRecentlyExpiredOnly;
            this.include_subteams_of_teams_in_filter = true;
            this.teams_ids = query.teamsIds.map((id) => parseInt(id));
            this.excluded_teams_ids = query.excludedTeamIds?.map((id) => parseInt(id)) || [];
            this.user_ids = query.userIds.map((id) => parseInt(id));
        } else {
            this.statuses = [];
            this.certifications_ids = [];
            this.certification_providers_ids = [];
            this.issue_date_from = null;
            this.issue_date_to = null;
            this.expiration_date_from = null;
            this.expiration_date_to = null;
            this.show_expiring_only = false;
            this.show_recently_expired_only = false;
            this.include_subteams_of_teams_in_filter = true;
            this.teams_ids = [];
            this.excluded_teams_ids = [];
            this.user_ids = [];
        }
    }
}
